import { useState, useEffect, useRef } from 'react';

const useCountUp = (end, duration = 1200, startOnMount = true) => {
    const [count, setCount] = useState(0);
    const startTime = useRef(null);
    const rafId = useRef(null);

    const start = () => {
        startTime.current = null;
        const animate = (timestamp) => {
            if (!startTime.current) startTime.current = timestamp;
            const progress = Math.min((timestamp - startTime.current) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            setCount(Math.floor(eased * end));
            if (progress < 1) {
                rafId.current = requestAnimationFrame(animate);
            }
        };
        rafId.current = requestAnimationFrame(animate);
    };

    useEffect(() => {
        if (startOnMount) start();
        return () => {
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [end, duration, startOnMount]);

    return { count, start };
};

export default useCountUp;
